import axios from 'axios';
import { notification } from 'antd';
import { logoutUnAuthenticat } from './auth';

const openNotificationWithIcon = (type, title, message) => {
  notification[type]({
    message: title,
    description: message,
  });
};

// Check if error message indicates token expiration
const isTokenExpiredError = (error: any): boolean => {
  // Check various possible error message locations
  const errorMessage = error?.response?.data?.message ||
    error?.message ||
    error?.data?.message ||
    error?.message ||
    (typeof error === 'string' ? error : '');

  if (!errorMessage) return false;

  const messageStr = String(errorMessage).toLowerCase();
  return (
    messageStr.includes('access token has expired') ||
    messageStr.includes('token has expired') ||
    messageStr.includes('token expired') ||
    messageStr.includes('please verify again') ||
    messageStr.includes('invalid or expired access token') ||
    messageStr.includes('expired access token')
  );
};

// Handle token expiration by logging out
const handleTokenExpiration = () => {
  logoutUnAuthenticat(() => {
    window.location.href = '/timesheet/login';
  });
};

export const getDesignation = (): any => async () => {
  const response = await axios.post(
    `${process.env.API_URL}/designation/getAllDesignation`
  );
  return response.data.data;
};

export const addDeveloperData =
  (data): any =>
    async () => {
      const response = await axios.post(
        `${process.env.API_URL}/pub/register`,
        data
      );
      return response.data.data;
    };

export const getDeveloperList = (): any => async () => {
  const response = await axios.get(`${process.env.API_URL}/pub/get/developer`);
  return response.data.data;
};

export const postData =
  (url, data, options: any = {}): any =>
    async () => {
      try {
        const baseURL = options.baseURL || process.env.API_URL;
        const response = await axios.post(`${baseURL + url}`, data);

        // Check if response indicates token expiration (backend returns code 301 with error message)
        if (isTokenExpiredError(response.data) ||
          response.data.code === 401 ||
          (response.data.code === 301 && isTokenExpiredError(response.data))) {
          handleTokenExpiration();
          return { code: 401, message: 'Access token has expired. Please verify again.' };
        }

        return response.data;
      } catch (error: any) {
        // Check if token expired
        if (isTokenExpiredError(error) || error?.response?.status === 401) {
          handleTokenExpiration();
          return { code: 401, message: 'Access token has expired. Please verify again.' };
        }
        return error;
      }
    };

export const putData =
  (url, data, notification = true): any =>
    async () => {
      try {
        const response = await axios.put(`${process.env.API_URL + url}`, data);
        if (response.data.code == 200) {
          return response.data.data;
        } else {
          // Check if token expired in response
          if (isTokenExpiredError(response.data) || response.data.code === 401) {
            handleTokenExpiration();
          }
          return response.data;
        }
      } catch (error: any) {
        // Check if token expired
        if (isTokenExpiredError(error) || error?.response?.status === 401) {
          handleTokenExpiration();
          return { code: 401, message: 'Access token has expired. Please verify again.' };
        }
        throw error;
      }
    };

